<template lang="pug">
.container
  el-form
    el-form-item(:label="$t('Method')")
      el-select(id="SendRequest-methodSelect", v-model='request.method', :placeholder='$t("Please select method")')
        el-option(v-for='requestMethod in requestMethods', :id="'SendRequest-'+requestMethod.value", :key='requestMethod.value', :label='requestMethod.label', :value='requestMethod.value')
    el-form-item(v-if='request.method === "customRequest"', :label="$t('Custom Method')")
      el-input(id="SendRequest-customMethodInput", v-model='request.customMethod', type="text")
    el-form-item(v-if='request.method === "customRequest"', :label="$t('Arguments')")
      el-input(id="SendRequest-customArgumentsInput", :placeholder="$t('{}')", v-model='request.args', type="textarea", @input='configParseError = false', :rows='7', :cols='40')
  .buttons
    el-button.float-right(id="SendRequest-submitButton", type="success", size="small", @click="sendOnDemandRequest()", :disabled="!this.request.method")
      font-awesome-icon(icon="upload")
      span &nbsp; {{ $t('send')}}
  .error(v-if='error.length > 0')
    span.warning {{ error }}
</template>

<script>
import Vue from 'vue'
import textUtils from '../Common/textUtils.mixin'
import deviceUtils from '../Common/deviceUtils.mixin'

export default {
  mixins: [textUtils, deviceUtils],
  components: {
  },
  props: ['side', 'device'],
  data () {
    return {
      error: '',
      loading: false,
      request: {
        method: null,
        customMethod: null,
        args: null
      },
      requestMethods: [
        { value: 'updateContent', label: this.$t('Re-send last Update Content') },
        { value: 'cancelContentUpdate', label: this.$t('Cancel Content Update') },
        { value: 'updateSchedule', label: this.$t('Update Player Schedule') },
        { value: 'updateScreenshot', label: this.$t('Make Screenshot') },
        { value: 'restartRenderer', label: this.$t('Restart Renderer') },
        { value: 'restartCore', label: this.$t('Restart Core') },
        { value: 'restartOS', label: this.$t('Restart OS') },
        { value: 'diagnosticsFetch', label: this.$t('Perform diagnostics test') },
        { value: 'diagnosticsFetchConfig', label: this.$t('Fetch current configuration') },
        { value: 'diagnosticsPing', label: this.$t('Network Ping') },
        { value: 'diagnosticsLogcat', label: this.$t('Fetch device logs') },
        { value: 'diagnosticsCacheInfo', label: this.$t('Lists media cache contents') },
        { value: 'diagnosticsCacheRead', label: this.$t('Fetch cache contents (playlist, pending playlist, schedule, device info)') },
        { value: 'customRequest', label: this.$t('Other') }
      ]
    }
  },
  async created () {
  },
  methods: {
    sendOnDemandRequest () {
      const method = this.request.customMethod ? this.request.customMethod : this.request.method
      let args = this.request.args ? this.request.args : '{}'
      if (args.length > 0) {
        try {
          args = JSON.parse(args)
        } catch (error) {
          this.error = this.$t('Error. Argument must be a valid JSON')
          return
        }
      }
      this.error = ''
      if (!this.device.DeviceDesktops[0].uuid) {
        this.error = this.$t('Cannot send on-demand request to device beacause first desktop has no uuid specified.')
        return
      }
      this.sendRequest(this.device.DeviceDesktops[0].id, method, args)
      this.$emit('requestSent', { id: this.device.DeviceDesktops[0].id, method, args })
    },
    async load () {
      this.loading = true
      for (const desktop of this.device.DeviceDesktops) {
        await Vue.axios
          .get('DeviceDesktop/' + desktop.id)
          .then(response => {
            this.requests = [...this.requests, ...response.data.Requests]
          })
      }
      this.requests.sort((b, a) => a.updatedAt - b.updatedAt)
      this.loading = false
    }
  },
  computed: {
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
.buttons {
  margin-bottom: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/Device/SendRequest.vue